<template>
  <div>
    <span class="inline-flex rounded-md shadow-sm">
      <button type="button"
              @click="click"
              :class="buttonStyle"
              class="inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white focus:outline-none focus:ring-blue-200">
        <slot>
          Click Me!
        </slot>
      </button>
    </span>

<!--    Notification modal for confirmation, if needed -->
    <notification-modal
        v-model:is-open="showNotificationModal"
        :give-option="requiresConfirmation"
        :is-error-modal="true"
        v-on:action="modalAction"
    >
      <template #title-content>
        Are you sure?
      </template>
      {{confirmationText}}
    </notification-modal>

<!--    Notification modal for the results -->
    <notification-modal
        v-model:is-open="showResultModal"
    >
      <template #title-content>
        Results
      </template>
      <ul>
        <li v-for="result in results">{{result}}</li>
      </ul>
    </notification-modal>
  </div>
</template>

<script>
import axios from "axios";
import NotificationModal from "@/components/elements/NotificationModal";

export default {
  name: "buttonAjax",
  components: {NotificationModal},
  props: {
    isDangerButton: {
      type: Boolean,
      default: false
    },
    ajaxTarget: {
      type: String,
      required: true,
    },
    ajaxData: {
      type: Object,
      default: () => ({})
    },
    confirmationText: {
      type: String,
      default: '',
    }
  },
  data(){
    return {
      showNotificationModal: false,
      showResultModal: false,
      results: [],
    }
  },
  methods: {
    click(){
      if(this.requiresConfirmation){
        this.showNotificationModal = true;
      } else {
        this.makeRequest();
      }
    },
    modalAction(e){
      if(e === true){
        this.makeRequest();
      }
    },
    makeRequest(){
      axios.post(this.ajaxTarget, this.ajaxData).then(
          response => {
            this.results = response.data.messages;
            this.showResultModal = true;
          }
      ).catch(
          error => {
            this.results = error.response.data.errors;
            this.showResultModal = true;
          }
      )
    }
  },
  computed:{
    buttonStyle(){
      if(this.isDangerButton){
        return 'bg-red-600 hover:bg-red-500 focus:border-red-700 active:bg-red-700';
      }
      return 'bg-blue-600 hover:bg-blue-500 focus:border-blue-700 active:bg-blue-700';
    },
    requiresConfirmation(){
      return this.confirmationText.length > 0;
    }
  }
}
</script>

<style scoped>

</style>